module.exports = __webpack_public_path__ + "static/media/photo-1555460285-763ba96917d2.f4e0e6d0.jfif";